import { createCommonjsModule, getDefaultExportFromCjs } from '../../../../_virtual/_commonjsHelpers.js';
import { a as arrayWithHoles } from './arrayWithHoles.js';
import { i as iterableToArrayLimit } from './iterableToArrayLimit.js';
import { u as unsupportedIterableToArray } from './unsupportedIterableToArray.js';
import { n as nonIterableRest } from './nonIterableRest.js';

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _slicedToArray = /*@__PURE__*/getDefaultExportFromCjs(slicedToArray);

export default _slicedToArray;
